import {
    CorporateActionType,
    CorporateActionTypeValue,
} from 'widgets/corpActions/data/CorporateActionType';
import {
    CorpActionTypeHolidayEnum,
    CorpActionTypeHolidayValue,
    isCorpActionHolidayType,
} from 'widgets/corpActions/data/HolidayType';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { CorporateActionsRequestDateSearchType } from 'widgets/corpActions/api/CorporateActionsRequest';
import { EnumMap, getEnumValue } from '@instinet-analytics/core-lib';

export const SymbolEventsType: EnumMap = {
    ...CorporateActionType,
    ...CorpActionTypeHolidayEnum,
};
export type SymbolEventsTypeValue =
    | CorporateActionTypeValue
    | CorpActionTypeHolidayValue;

export interface SymbolEventsRequest {
    types?: string;
    symbols: string;
    symbology: SymbologyValues;
    dateSearchType: CorporateActionsRequestDateSearchType;
    lookbackPeriod?: string;
    lookforwardPeriod?: string;
    limit?: number;
}

export function getSymbolEventTypeValue(type: SymbolEventsTypeValue): string {
    return isCorpActionHolidayType(type)
        ? getEnumValue(CorpActionTypeHolidayEnum, type)
        : getEnumValue(CorporateActionType, type);
}
